import React, { Component } from 'react';
import './CustomNav.css';
import { PlayerCard } from './PlayerCard';
import { TeamManagement } from '../Pages/TeamManagement';
import { Trade } from '../Pages/Trade';
import { Apps } from '../Pages/App';
// import { Navbar, Nav, NavItem, Grid, Row, Col, Panel, Button } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
export class CustomNav extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { data } = this.state;
    return (
      <div className="header">
        <div className="header-left-side">
          <div className="header-title-row">
            <h2
              style={{
                fontWeight: '600',
                letterSpacing: '2.2px',
                display: 'inline-block',
                padding: '0em'
              }}
            >
              HOCKEY DATA SCIENCE CENTER
            </h2>
          </div>
          <div className="header-button-row">
            <Link to="/">
              <button className="header-nav-button">HOME</button>
            </Link>
            <Link to="/team">
              <button className="header-nav-button">TEAM</button>
            </Link>
            <Link to="/trade">
              <button className="header-nav-button">TRADE</button>
            </Link>
            <Link to="/cap">
              <button className="header-nav-button">CAP</button>
            </Link>
            <Link to="/contract">
              <button className="header-nav-button">CONTRACT</button>
            </Link>
            {/* <Link to='/contract'><button className="header-nav-button">CAP MANAGEMENT</button></Link> */}
            {/*
            <Link to="/research">
              <button className="header-nav-button">STATS</button>
            </Link>
            <Link to="/wizard">
              <button className="header-nav-button">WIZARD</button>
            </Link>
            */}
            <Link to="/draft">
              <button className="header-nav-button">SCOUTING</button>
            </Link>
            <Link to="/prop">
              <button className="header-nav-button">SCENARIOS</button>
            </Link>
            {/*  <Link to="/managers">
              <button className="header-nav-button">GENERAL MANAGERS</button>
            </Link>*/}
            {/*<Link to='/players'><button className="header-nav-button">PLAYERS</button></Link>*/}
          </div>
        </div>
        <div className="header-right-side">
          <Link to="/account">
            <button className="header-account-button">MY ACCOUNT</button>
          </Link>
        </div>
      </div>
    );
  }
}
('');



// WEBPACK FOOTER //
// ./src/Components/CustomNav.js